<template>
  <div class="body">
    <a-back-top />
    <Sidebar />
    <Header id="index" :data="allData.pc?.header" />
    <!-- <LivePlayer /> -->
    <playback id="playback" :data="2025"></playback>
    <About id="about" :data="allData.pc?.about" />
    <Activity id="activity" :data="allData.pc?.activity" />
    <Highlight id="highlight" :data="allData.pc?.highlight" />
    <Agenda id="agenda" :data="agendaInfo" />
    <Lesson id="lesson" :data="allData.pc?.lesson" />
    <Guest id="guest" :data="allData.pc?.guest" />
    <News id="news" :data="allData.pc?.news" />
    <Partner id="partner" :data="partenrInfo" />
    <Business />
  </div>
</template>

<script setup>
import { ref, onBeforeMount, onMounted } from 'vue'
import { getRecruit } from '@/api/2024/index'
import Sidebar from './isc/sidebar.vue'
import Header from './isc/header.vue'
import playback from '@/components/playback/playback.vue'
import About from './isc/about.vue'
import Activity from './isc/activity.vue'
import Highlight from './isc/highlight.vue'
import Agenda from './isc/agenda.vue'
import Lesson from './isc/lesson.vue'
import Guest from './isc/guest.vue'
import News from './isc/news.vue'
import Business from './isc/business.vue'
import Partner from './isc/partner.vue'
// import LivePlayer from '../livePlayer/web.vue'
const agendaInfo = ref({})
const partenrInfo = ref({})
const allData = ref({
  // pc:{
  //   header:{
  //     showVideo: false,
  //     videoUrl: 'https://isc.360kan.com/vod-isc-vod-101240-beijing/TL730b7df625e5454f3cb3ccd3878c4fdc.mp4',
  //     bgUrl: 'https://p0.ssl.qhimg.com/t110b9a930158eb31cca412674c.png',
  //     imgUrl: 'https://p4.ssl.qhimg.com/t110b9a9301f515a9b8e83f580b.png'
  //   },
  //   about:{
  //     titleCn: '关于大会',
  //     titleEn: 'CONFERENCE INTRODUCTION',
  //     contentText: 'ISC.AI大会是全球规格最高、规模最大、覆盖最广、影响力最深远的AI+安全双域峰会，自2013年肇始迄今累计设立超600场分论坛，输出超4500个行业前沿议题，吸引来自全球30多个国家的2000余位政要、行业领袖、专家学者的深度参与，被誉为全球AI及数字安全行业风向标。<p style="margin-top: 10px">2025年，全球大模型技术参数规模跨入百万亿级，正加速走进百行千业，成为推动我国科技进步、经济增长和国家强盛的关键力量。然而技术狂飙下，大模型安全漏洞呈指数级增长，迫使AI与安全进入共生新纪元。在此变革浪潮中，ISC.AI 2025大会正式启动，本届大会以“构建全球数智共同体”为目标，汇聚全球政要、行业领袖、专家学者，共同破解智能时代的“安全方程”，通过建立政产学研用协同创新体系，进一步推动大模型产业价值释放和数字安全行业跃迁。</p>',
  //     imgUrl: 'https://p3.ssl.qhimg.com/t110b9a93015b6d554a2abca28b.png'
  //   },
  //   activity:{
  //     titleCn: '大会板块',
  //     titleEn: 'CONFERENCE SECTION',
  //     imgUrl: 'https://p0.ssl.qhimg.com/t110b9a93014ccdf83c153b3fae.png',
  //     list:[
  //       {
  //         imgUrl: 'https://p2.ssl.qhimg.com/t110b9a930113cf0a7b9eff26b9.png',
  //         linkUrl: 'https://isc.360.com/new/2025/event/signup.html',
  //       },
  //       {
  //         imgUrl: 'https://p3.ssl.qhimg.com/t110b9a93016b7f0bf7648b602a.png',
  //         linkUrl: 'https://isc.360.com/new/2025/event/promotion.html',
  //       },
  //     ]
  //   },
  //   highlight:{
  //     titleCn: '大会亮点',
  //     titleEn: 'HIGH LIGHTS',
  //     imgUrl: 'https://p5.ssl.qhimg.com/t110b9a9301b5f983418db8b30e.png',
  //     list:[
  //       {
  //         marginTop: 278,
  //         content:'全球智囊与一线技术大咖现场“授课”，覆盖人人智能、万物智能、数转智改、未来产业、科学研究、数智安全六大领域前沿议题方向。'
  //       },
  //       {
  //         marginTop: 331,
  //         content:'N+模型与应用、趋势与报告发布，集中引爆“AI寒武纪”。'
  //       },
  //       {
  //         marginTop: 278,
  //         content:'数字安全与AI领域千家企业深度参与，覆盖政企、金融、能源等万亿市场，将现场促成战略合作、供需对接、产业投资。'
  //       },
  //       {
  //         marginTop: 331,
  //         content:'依托现象级AI应用——纳米AI重塑会展赛各板块，形成“感知-交互-共创”三维沉浸体验，定义下一代科技会议范式。'
  //       },
  //       {
  //         marginTop: 278,
  //         content:'打造5000㎡ AI+数字安全沉浸式展区，以及ISC Talk、赛博文化街、AI体验展三大互动区，构建集创新探索与潮玩体验以及美学打卡于一体的科技新地标。'
  //       }
  //     ]
  //   },
  //   lesson:{
  //     titleCn: '精彩回顾',
  //     titleEn: 'WONDERFUL REVIEW',
  //     list:[
  //       {
  //           "video": "https://cdn.isc.360.com/iscvideo-bucket/2024-isc.ai%E5%91%A8%E9%B8%BF%E7%A5%8E.mp4",
  //           "pic": "https://p5.ssl.qhimg.com/t110b9a930128b8a993149277a9.png",
  //           "desc": "打造安全大模型 引领安全行业革命"
  //       },
  //       {
  //           "video": "https://cdn.isc.360.com/iscvideo-bucket/2024-isc.ai%E5%BC%A0%E9%92%B9.mp4",
  //           "pic": "https://p4.ssl.qhimg.com/t110b9a93013abb77c20dead674.png",
  //           "desc": "生成式人工智能时代的AI产业-迈向第三代人工智能"
  //       },
  //       {
  //           "video": "https://cdn.isc.360.com/iscvideo-bucket/2024-isc.ai%E5%90%B4%E4%B8%96%E5%BF%A0.mp4",
  //           "pic": "https://p0.ssl.qhimg.com/t110b9a93019c17b2ad3901debd.png",
  //           "desc": "对生成式AI安全研究的几点观察"
  //       },
  //       {
  //           "video": "https://cdn.isc.360.com/iscvideo-bucket/2024-isc.ai%E9%82%AC%E6%B1%9F%E5%85%B4.mp4",
  //           "pic": "https://p5.ssl.qhimg.com/t110b9a930162dbc8218e1dad0f.png",
  //           "desc": "AI应用系统内生安全问题及解决方法研究"
  //       },
  //       {
  //           "video": "https://cdn.isc.360.com/iscvideo-bucket/2024-isc.ai%E9%82%AC%E8%B4%BA%E9%93%A8.mp4",
  //           "pic": "https://p1.ssl.qhimg.com/t110b9a9301b3cb8c19974209e4.png",
  //           "desc": "领导致辞"
  //       },
  //       {
  //           "video": "https://cdn.isc.360.com/iscvideo-bucket/2024-isc.ai%E9%BE%9A%E5%85%8B.mp4",
  //           "pic": "https://p5.ssl.qhimg.com/t110b9a930110d74208bce96c59.png",
  //           "desc": "发展开放安全人工智能:怎么看、怎么办"
  //       }
  //     ]
  //   },
  //   guest:{
  //     titleCn: '重磅嘉宾',
  //     titleEn: 'IMPORTANT GUESTS',
  //   },
  //   news:{
  //     titleCn: '新闻报道',
  //     titleEn: 'NEWS REPORT',
  //     jumpMore: 'https://www.anquanke.com/subject.html?id=307179',
  //     list:[
  //       {
  //         title: '专家提醒关注网络安全行业因使用',
  //         desc: '大语言模型劫持（LLMjacking）攻击瞄准 DeepSeek，导致云成本飙升。Sysdig 公司揭示，如今已出现了一个大语言模型访问权限的黑市，其中运营反向代理的方法酒店客房健康的',
  //         time: '2024-05-09 09:00:00',
  //         linkUrl: 'https://www.anquanke.com/post/id/307179'
  //       },
  //       {
  //         title: '专家提醒关注网络安全行业因使用人工智能（AI）功能带来的成本上升的问题',
  //         desc: '大语言模型劫持（LLMjacking）攻击瞄准 DeepSeek，导致云成本飙升。Sysdig 公司揭示，如今已出现了一个大语言模型访问权限的黑市，其中运营反向代理发动机疯狂东方酒店客房酒店',
  //         time: '2024-05-09 09:00:00',
  //         linkUrl: 'https://www.anquanke.com/post/id/307179'
  //       },
  //     ]
  //   }
  // },
  // mobile:{
  //   header:{
  //     showVideo: false,
  //     videoUrl: 'https://isc.360kan.com/vod-isc-vod-101240-beijing/TL730b7df625e5454f3cb3ccd3878c4fdc.mp4',
  //     bgUrl: 'https://p4.ssl.qhimg.com/t110b9a930139ed7e2cb74b5402.png',
  //     imgUrl: 'https://p1.ssl.qhimg.com/t110b9a93012ec1b588196bc964.png'
  //   },
  //   about:{
  //     titleCn: '关于大会',
  //     titleEn: 'CONFERENCE INTRODUCTION',
  //     contentText: 'ISC.AI大会是全球规格最高、规模最大、覆盖最广、影响力最深远的AI+安全双域峰会，自2013年肇始迄今累计设立超600场分论坛，输出超4500个行业前沿议题，吸引来自全球30多个国家的2000余位政要、行业领袖、专家学者的深度参与，被誉为全球AI及数字安全行业风向标。<p style="margin-top: 10px">2025年，全球大模型技术参数规模跨入百万亿级，正加速走进百行千业，成为推动我国科技进步、经济增长和国家强盛的关键力量。然而技术狂飙下，大模型安全漏洞呈指数级增长，迫使AI与安全进入共生新纪元。在此变革浪潮中，ISC.AI 2025大会正式启动，本届大会以“构建全球数智共同体”为目标，汇聚全球政要、行业领袖、专家学者，共同破解智能时代的“安全方程”，通过建立政产学研用协同创新体系，进一步推动大模型产业价值释放和数字安全行业跃迁。</p>',
  //     imgUrl: 'https://p1.ssl.qhimg.com/t110b9a93016ea9d8dcee1c9d1e.png'
  //   },
  //   activity:{
  //     titleCn: '大会板块',
  //     titleEn: 'CONFERENCE SECTION',
  //     imgUrl: 'https://p2.ssl.qhimg.com/t110b9a9301dfeced9acaca637d.png',
  //     list:[
  //       {
  //         imgUrl: 'https://p2.ssl.qhimg.com/t110b9a930113cf0a7b9eff26b9.png',
  //         linkUrl: 'https://isc.360.com/new/2025/event/signup.html',
  //       },
  //       {
  //         imgUrl: 'https://p3.ssl.qhimg.com/t110b9a93016b7f0bf7648b602a.png',
  //         linkUrl: 'https://isc.360.com/new/2025/event/promotion.html',
  //       },
  //     ]
  //   },
  //   highlight:{
  //     titleCn: '大会亮点',
  //     titleEn: 'HIGH LIGHTS',
  //     list:[
  //       {
  //         imgUrl:'https://p2.ssl.qhimg.com/t110b9a93016485304175622c36.png',
  //         content:'全球智囊与一线技术大咖现场“授课”，覆盖人人智能、万物智能、数转智改、未来产业、科学研究、数智安全六大领域前沿议题方向。'
  //       },
  //       {
  //         imgUrl:'https://p2.ssl.qhimg.com/t110b9a930187c310d1abc83995.png',
  //         content:'N+模型与应用、趋势与报告发布，集中引爆“AI寒武纪”。'
  //       },
  //       {
  //         imgUrl:'https://p5.ssl.qhimg.com/t110b9a93017a90032ffbf5ce25.png',
  //         content:'数字安全与AI领域千家企业深度参与，覆盖政企、金融、能源等万亿市场，将现场促成战略合作、供需对接、产业投资。'
  //       },
  //       {
  //         imgUrl:'https://p4.ssl.qhimg.com/t110b9a9301d2613b73a0dff2e3.png',
  //         content:'依托现象级AI应用——纳米AI重塑会展赛各板块，形成“感知-交互-共创”三维沉浸体验，定义下一代科技会议范式。'
  //       },
  //       {
  //         imgUrl:'https://p5.ssl.qhimg.com/t110b9a93019889843b4bd89b14.png',
  //         content:'打造5000㎡ AI+数字安全沉浸式展区，以及ISC Talk、赛博文化街、AI体验展三大互动区，构建集创新探索与潮玩体验以及美学打卡于一体的科技新地标。'
  //       }
  //     ]
  //   },
  //   lesson:{
  //     titleCn: '精彩回顾',
  //     titleEn: 'WONDERFUL REVIEW',
  //     list:[
  //       {
  //         list:[
  //           {
  //               "video": "https://cdn.isc.360.com/iscvideo-bucket/2024-isc.ai%E5%91%A8%E9%B8%BF%E7%A5%8E.mp4",
  //               "pic": "https://p5.ssl.qhimg.com/t110b9a930128b8a993149277a9.png",
  //               "desc": "打造安全大模型 引领安全行业革命"
  //           },
  //           {
  //               "video": "https://cdn.isc.360.com/iscvideo-bucket/2024-isc.ai%E5%BC%A0%E9%92%B9.mp4",
  //               "pic": "https://p4.ssl.qhimg.com/t110b9a93013abb77c20dead674.png",
  //               "desc": "生成式人工智能时代的AI产业-迈向第三代人工智能"
  //           }
  //         ]
  //       },
  //       {
  //         list:[
  //           {
  //               "video": "https://cdn.isc.360.com/iscvideo-bucket/2024-isc.ai%E5%90%B4%E4%B8%96%E5%BF%A0.mp4",
  //               "pic": "https://p0.ssl.qhimg.com/t110b9a93019c17b2ad3901debd.png",
  //               "desc": "对生成式AI安全研究的几点观察"
  //           },
  //           {
  //               "video": "https://cdn.isc.360.com/iscvideo-bucket/2024-isc.ai%E9%82%AC%E6%B1%9F%E5%85%B4.mp4",
  //               "pic": "https://p5.ssl.qhimg.com/t110b9a930162dbc8218e1dad0f.png",
  //               "desc": "AI应用系统内生安全问题及解决方法研究"
  //           }
  //         ]
  //       },
  //       {
  //         list:[
  //           {
  //               "video": "https://cdn.isc.360.com/iscvideo-bucket/2024-isc.ai%E9%82%AC%E8%B4%BA%E9%93%A8.mp4",
  //               "pic": "https://p1.ssl.qhimg.com/t110b9a9301b3cb8c19974209e4.png",
  //               "desc": "领导致辞"
  //           },
  //           {
  //               "video": "https://cdn.isc.360.com/iscvideo-bucket/2024-isc.ai%E9%BE%9A%E5%85%8B.mp4",
  //               "pic": "https://p5.ssl.qhimg.com/t110b9a930110d74208bce96c59.png",
  //               "desc": "发展开放安全人工智能:怎么看、怎么办"
  //           }
  //         ]
  //       }
  //     ]
  //   },
  //   guest:{
  //     titleCn: '重磅嘉宾',
  //     titleEn: 'IMPORTANT GUESTS',
  //   },
  //   news:{
  //     titleCn: '新闻报道',
  //     titleEn: 'NEWS REPORT',
  //     jumpMore: 'https://www.anquanke.com/subject.html?id=307179',
  //     list:[
  //       {
  //         title: '专家提醒关注网络安全行业因使用',
  //         desc: '大语言模型劫持（LLMjacking）攻击瞄准 DeepSeek，导致云成本飙升。Sysdig 公司揭示，如今已出现了一个大语言模型访问权限的黑市，其中运营反向代理的方法酒店客房健康的',
  //         time: '2024-05-09 09:00:00',
  //         linkUrl: 'https://www.anquanke.com/post/id/307179'
  //       },
  //       {
  //         title: '专家提醒关注网络安全行业因使用人工智能（AI）功能带来的成本上升的问题',
  //         desc: '大语言模型劫持（LLMjacking）攻击瞄准 DeepSeek，导致云成本飙升。Sysdig 公司揭示，如今已出现了一个大语言模型访问权限的黑市，其中运营反向代理发动机疯狂东方酒店客房酒店',
  //         time: '2024-05-09 09:00:00',
  //         linkUrl: 'https://www.anquanke.com/post/id/307179'
  //       },
  //     ]
  //   }
  // }
})

onBeforeMount(async () => {
  await fetch()
})
onMounted(() => {
  //整体缩放
    let resizeWindow = function (){
        let root = document.getElementById("app");
        if(window.innerWidth<1480){
            let fangdabili = window.innerWidth / 1480;
            root.style.transformOrigin = `0 0`       
            root.style.transform = `scale(${fangdabili})`       
            root.style.width = `${100/fangdabili}vw`      
            // root.style.padding = `${180/fangdabili}px 0 0`  
            root.style.height = `${100/fangdabili}vh`       
        }else{
            root.style.transformOrigin = ``       
            root.style.transform = ``       
            root.style.width = ``       
            root.style.height = `` 
        }
    }
    resizeWindow()
    window.addEventListener("resize",()=>{
        resizeWindow()
    })
})
const fetch = () => {
  getRecruit('dUt4REhnN0o5T1FZY3BSem1DcjRjQT09OjpL0OCuQnEV1ClVXBiET5sa')
    .then((res) => {
        allData.value = JSON.parse(res.data.data.data)
    })
    .catch(() => {})

    getRecruit('cGVSTUhOSXo3c1FGVW5ZU1gxMk12QT09OjrxGJpKgbirdzw5PVxz3S6r')
    .then((res) => {
        agendaInfo.value = JSON.parse(res.data.data.data).agenda
    })
    .catch(() => {})

    getRecruit('M1d6ZXZ1RHFieEt2cE1uWk8rYXlxQT09OjpibQ2u5hfB9s/AduqQnBS5')
    .then((res) => {
      partenrInfo.value = JSON.parse(res.data.data.data)
        // console.log(partenrInfo.value,22288)
    })
    .catch(() => {})
}
</script>

<style lang="scss" scoped>
.body {
  position: relative;
  background: rgb(247, 249, 253);
  overflow: hidden;
}
</style>
